import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

// Fires a GA4 page_view on every SPA route change (path + search).
export function usePageTracking() {
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname + location.search;
    // defer so document.title reflects the new route
    const id = window.setTimeout(() => trackPageView(path, document.title), 0);
    return () => window.clearTimeout(id);
  }, [location.pathname, location.search]);
}
